const APP_FLAGS = {};
const SCHOOL_FLAGS = {
    WALLET_ENABLED: 'Wallet Beta',
    DIRECTORY: 'directory',
};
const TEAM_FLAGS = {};
const USER_FLAGS = {};
const BRAND_FLAGS = {
    AGREEMENTS_V2_UX: 'Agreements v2 UX',
    SIGNATURES: 'Signatures',
};
const FEATURE_FLAGS = {
    AGREEMENTS_V2: 'agreements-v-2',
    WALLET_BETA: 'wallet-beta',
    CONTENT_TASKS: 'content-tasks',
};
export { APP_FLAGS, SCHOOL_FLAGS, TEAM_FLAGS, USER_FLAGS, BRAND_FLAGS, FEATURE_FLAGS, };
